import { Button } from "pepsico-ds";
import { useContext } from "react";
import { CampaignSetupContext } from "../../../context/CampaignSetupContext";
import { GlobalConfigContext } from "../../../context/GlobalConfigContext";

const CheckInGeoTableComponent = ({ data }) => {
  const campaignContext = useContext(CampaignSetupContext);
  const globalContext = useContext(GlobalConfigContext);
  const { campaignState } = campaignContext;
  const {
    globalState: { programConfig },
  } = globalContext;

  const generateDeepLinkUrls = () => {
    const appConfig = programConfig?.configurations?.find(
      (config) => config?.key === "app_configurations"
    );
    const deepLinkUrl = appConfig?.value?.data?.checkInDeepLinkUrl;

    const activityWithGeoCheckIn = campaignState?.activities?.find((activity) =>
      activity.activityRules?.some(
        (rule) => rule.ruleDefinition?.slug === "check-in-at-geolocation"
      )
    );

    const activityId = activityWithGeoCheckIn?.id;
    const campaignId = campaignState?.id ?? "";

    const locations = activityWithGeoCheckIn?.activityRules
      ?.filter((rule) => rule.ruleDefinition?.slug === "check-in-at-geolocation")
      .flatMap((rule) => rule.ruleData?.locations || []);

    if (!locations?.length) return [];

    const urls = locations.map(({ referral_id }) => {
      const params = new URLSearchParams({
        activityId,
        identifier: referral_id,
        campaignId,
      });

      return `${deepLinkUrl}&${params.toString()}`;
    });

    return urls;
  };

  const downloadUrlsAsCsv = (urls) => {
    const header = "identifier,url\n";
    const rows = urls
      .map((url) => {
        const urlObj = new URL(url);
        const identifier = urlObj.searchParams.get("identifier") || "";
        return `${identifier},${url}`;
      })
      .join("\n");

    const csvContent = header + rows;
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.href = url;
    link.download = "deep_links.csv";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  return (
    <div className="w-100 font-sm">
      <div className="flex align-items-center mt-2 justify-content-space-between">
        <div>
          <strong>Require Geolocation:</strong>{" "}
          {data?.require_geolocation ? "Yes" : "No"}
        </div>
        <div>
          <strong>Display locations in map:</strong>{" "}
          {data?.display_locations_in_map ? "Yes" : "No"}
        </div>
        <div>
          <strong>Radius:</strong> {data?.radius ?? "N/A"}
        </div>
        <div>
          <Button
            variant="secondary"
            size="small"
            onClick={() => {
              const urls = generateDeepLinkUrls();
              downloadUrlsAsCsv(urls);
            }}
          >
            Download Links
          </Button>
        </div>
      </div>
      <table className="w-100 mt-2 mb-2 text-left">
        <thead>
          <tr>
            <th>Name</th>
            <th>Image</th>
            <th>Description</th>
            <th>Referral ID</th>
            <th>Latitude</th>
            <th>Longitude</th>
          </tr>
        </thead>
        <tbody className="font-xs">
          {data?.locations?.map((loc, index) => (
            <tr key={index}>
              <td>{loc.name || "N/A"}</td>
              <td>
                {loc.image ? (
                  <img
                    src={loc.image}
                    alt={loc.name || "Location"}
                    style={{
                      width: "50px",
                      height: "50px",
                      objectFit: "cover",
                      borderRadius: "4px",
                    }}
                  />
                ) : (
                  "N/A"
                )}
              </td>
              <td>{loc.description || "N/A"}</td>
              <td>{loc.referral_id}</td>
              <td>{loc.latitude ?? "N/A"}</td>
              <td>{loc.longitude ?? "N/A"}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default CheckInGeoTableComponent;
